import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Trophy, Award, BadgeCheck } from "lucide-react";
import { fadeUp, stagger, viewport } from "./anim";

const creds = [
  { icon: GraduationCap, label: "Ph.D. — Curriculum & Instruction" },
  { icon: Trophy, label: "3× President's Club Qualifier" },
  { icon: Award, label: "Top SDR Award Winner" },
  { icon: BadgeCheck, label: "AI Consultant Certified (in progress)" },
];

export const Founder = () => {
  return (
    <section id="founder" data-testid="founder-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="blob w-[28rem] h-[28rem] left-0 top-20 animate-blob" style={{ background: "rgba(192,132,252,0.16)" }} />
      <div className="blob w-[24rem] h-[24rem] right-0 bottom-10 animate-blob" style={{ background: "rgba(233,51,198,0.12)", animationDelay: "-7s" }} />

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={viewport}
        variants={stagger}
        className="relative z-10 max-w-3xl mx-auto px-5 sm:px-8 text-center"
      >
        <motion.div variants={fadeUp} className="font-mono-accent text-xs tracking-[0.25em] uppercase text-fuchsia-600 mb-4">
          The Builder, Not Just The Talker
        </motion.div>
        <motion.h2 variants={fadeUp} className="font-display font-bold text-slate-900 text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1]">
          Before I built AI tools, <span className="text-gradient">I taught.</span>
        </motion.h2>

        <motion.div variants={fadeUp} className="mt-4">
          <div className="font-display font-bold text-slate-900 text-lg">Melanie Stewart, Ph.D.</div>
          <div className="font-mono-accent text-[10px] tracking-[0.2em] uppercase text-fuchsia-500 mt-1">
            Founder — Activate Then Elevate
          </div>
        </motion.div>

        <motion.div variants={fadeUp} className="mt-8 space-y-5 text-slate-700 text-base sm:text-lg leading-relaxed text-left sm:text-center">
          <p>
            K-12 classrooms, adjunct college courses, corporate training rooms — every one of them
            had people who were skeptical, resistant, or just plain intimidated by something new.
            My job was to make the unfamiliar feel possible. That's exactly what I do now with AI.
          </p>
          <p>
            I've spent my career in sales too — three-time President's Club qualifier, Top SDR award
            winner — which means I know what it's like to be handed a tool and told "figure it out."
            Activate Then Elevate exists so nobody else has to.
          </p>
          <p className="text-slate-900 font-medium">
            Everything I build for clients, I build for my own businesses first. If it doesn't work
            for me, it doesn't go out the door.
          </p>
        </motion.div>

        <motion.div variants={fadeUp} className="mt-10 grid sm:grid-cols-2 gap-3 text-left">
          {creds.map((c) => {
            const Icon = c.icon;
            return (
              <div key={c.label} className="flex items-center gap-3 rounded-xl px-4 py-3 bg-white border border-fuchsia-100 shadow-sm">
                <Icon size={18} className="text-fuchsia-600 shrink-0" />
                <span className="text-sm font-medium text-slate-700">{c.label}</span>
              </div>
            );
          })}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Founder;
